// extracted by mini-css-extract-plugin
export default {"Approve":"_Approve--Tk0Ni","Small":"_Small--JGojV","ToolTip":"_ToolTip--Xax9o"};